import React, {createContext, useContext, useReducer} from "react";
import {StoresReducer} from "stores/reducer/StoresReducer";

export const StoresContext = createContext();

// Create a provider for its descendants to consume and subscribe to changes
export const StoresProvider = props => {
    const [state, dispatch] = useReducer(...StoresReducer);

    return <StoresContext.Provider value={[state, dispatch]} {...props} />;
};
export const useStores = () => useContext(StoresContext);

